export const UNIT_OPTIONS = [
  { value: 'comprimido', label: 'Comprimido', short: 'comp.' },
  { value: 'gotas', label: 'Gotas', short: 'gotas' },
  { value: 'ml', label: 'ml', short: 'ml' },
  { value: 'ampola', label: 'Ampola', short: 'amp.' }
]

export const ROUTES = ['VO / Oral', 'EV / Intravenosa', 'IM / Intramuscular', 'SC / Subcutânea', 'Inalatória', 'Tópica']

export const INTERVALS = [4, 6, 8, 12, 24]

export const DOSE_STATUS = {
  pendente: 'Pendente',
  atrasado: 'Atrasado',
  administrado: 'Administrado',
  recusado: 'Recusado'
}

export function unitShort(unit) {
  return UNIT_OPTIONS.find((item) => item.value === unit)?.short || unit || 'un.'
}

export function stockLabel(item) {
  const stock = Number(item.current_stock || 0)
  const text = Number.isInteger(stock) ? String(stock) : stock.toFixed(1).replace(/\.0$/, '')
  return `${text} ${unitShort(item.unit_type)}`
}

export function scheduleLabel(item) {
  if (item.schedule_kind === 'se_necessario') return 'Se necessário'
  if (item.schedule_kind === 'horarios') return (item.dose_times || []).join(', ') || 'Horários'
  if (item.interval_hours && item.first_dose_time) return `${item.interval_hours}/${item.interval_hours}h a partir das ${item.first_dose_time}`
  return 'Intervalo'
}

export function routeShort(route) {
  const text = String(route || '')
  if (/oral/i.test(text)) return 'ORAL'
  if (/\bEV\b|venosa/i.test(text)) return 'EV'
  if (/\bIM\b|muscular/i.test(text)) return 'IM'
  if (/\bSC\b|subcut/i.test(text)) return 'SC'
  if (/inal/i.test(text)) return 'INALATÓRIA'
  if (/t[oó]p/i.test(text)) return 'TÓPICA'
  return text.split('/')[0].trim().toUpperCase() || 'VIA'
}

export function cadenceShort(item) {
  if (item.schedule_kind === 'intervalo' && item.interval_hours) return `${item.interval_hours}/${item.interval_hours}`
  if (item.schedule_kind === 'horarios') return (item.dose_times || []).join(' · ') || 'horários'
  return 'SN'
}

export function shiftDate(iso, days) {
  const [year, month, day] = String(iso).split('-').map(Number)
  const date = new Date(year, month - 1, day)
  date.setDate(date.getDate() + days)
  const nextMonth = String(date.getMonth() + 1).padStart(2, '0')
  const nextDay = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${nextMonth}-${nextDay}`
}

export function dayHeading(iso) {
  const [year, month, day] = String(iso).split('-').map(Number)
  const label = new Date(year, month - 1, day).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
  return iso === todayInputValue() ? `Hoje, ${label}` : label
}

export function todayInputValue() {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(new Date()).map((part) => [part.type, part.value]))
  return `${parts.year}-${parts.month}-${parts.day}`
}
